$(function() {
    "use strict";

    var rateWrapperSelector = '.review-stars';
    var rateWrapperEditableSelector = '.review-stars_editable';
    var starSelector = '.review-stars__star';
    var starSelectedClass = 'review-stars__star_selected';

    $(document).on('click', rateWrapperEditableSelector + ' ' + starSelector, function() {
        var $star = $(this);
        $star.siblings(starSelector).removeClass(starSelectedClass);
        $star.addClass(starSelectedClass);
        $star.prevAll(starSelector).addClass(starSelectedClass);

        var rate = $star.prevAll(starSelector).length + 1;
        $(this).closest(rateWrapperEditableSelector).find('.review-stars__rate').val(rate);
    });
});